import { cn } from '@/lib/utils';
import { ChevronRight } from 'lucide-react';
import React from 'react';
interface PaymentMethodButtonProps {
  method: string;
  icon: React.ReactNode;
  className?: string;
  onClick?: () => void;
}
function PaymentMethodButton({
  method,
  icon,
  className,
  onClick
}: PaymentMethodButtonProps) {
  return <button type="button" className={cn(`flex w-full items-center justify-between rounded-xl border border-gray-100 bg-white p-2 shadow-lg`, className)} onClick={onClick} data-sentry-component="PaymentMethodButton" data-sentry-source-file="payment-method-button.tsx">
      <div className="flex items-center gap-3">
        <div className="flex size-10 items-center justify-center rounded-full">
          {icon}
        </div>
        <div className="flex flex-col justify-start text-left">
          <span className="font-medium">{method}</span>
          <span className="text-xs">
            Link your
            {' '}
            {method}
          </span>
        </div>
      </div>
      <div className="z-0 my-auto flex items-center justify-center gap-1.5 overflow-hidden rounded-[34px] bg-x-button-background p-1 text-center text-base font-medium text-x-accent-alpha group-hover:bg-white/20 ">
        <ChevronRight className="size-3 group-hover:text-white" data-sentry-element="ChevronRight" data-sentry-source-file="payment-method-button.tsx" />
      </div>
    </button>;
}
;
export default PaymentMethodButton;